<template>
  <v-card>
    <v-form ref="editBatchForm" @submit.prevent="submitEditBatch()">
      <v-container style="padding-bottom: 0px">
        <v-layout row wrap>
          <v-flex xs12 class="flex-container-space-between">
            <span class="headline">
              Edit
              <span class="grey--text subheading">- Batch {{batch.id}}</span>
            </span>
            <v-btn icon @click="addLineDialog = true" :disabled="closed">
              <v-icon color="grey">add</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs12 sm6>
            <date-picker-wrapper
              :disabled="closed"
              v-model="editedBatch.date"
              :rules="dateRules"
              label="Date"
              color="primary"
            ></date-picker-wrapper>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              :disabled="closed"
              label="* Site"
              color="primary"
              :items="sites"
              v-model="editedBatch.siteId"
              item-text="siteName_projectName"
              item-value="id"
              :loading="loadingSites"
              :rules="siteRules"
              :prepend-icon="$store.state.global.pages.site.icon"
              clearable
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              :disabled="closed"
              label="Notes"
              color="primary"
              v-model="editedBatch.notes"
              :rules="notesRules"
              prepend-icon="note"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-switch
              :disabled="closed"
              v-model="editedBatch.day"
              label="Day"
              color="amber darken-1"
              style="margin-top: 0px"
            ></v-switch>
          </v-flex>

          <!-- CONFIRMATIONS -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Batch Confirmations</div>
          </v-flex>
          <v-flex xs4 class="flex-container-space-between">
            <v-autocomplete
              :prepend-icon="$store.state.global.pages.tip.icon"
              label="Tip Status"
              :items="statusOptions"
              v-model="editedBatch.tipConfirmed"
              color="indigo"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs8 class="flex-container-space-between">
            <v-text-field
              v-model="editedBatch.tipNotes"
              label="Tip notes"
              type="text"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="flex-container-space-between">
            <v-autocomplete
              :prepend-icon="$store.state.global.pages.site.icon"
              label="Site Status"
              :items="statusOptions"
              v-model="editedBatch.siteConfirmed"
              color="indigo"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs8 class="flex-container-space-between">
            <v-text-field
              v-model="editedBatch.siteNotes"
              label="Site notes"
              type="text"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="flex-container-space-between">
            <v-autocomplete
              prepend-icon="post_add"
              label="Amendments Status"
              :items="statusOptions"
              v-model="editedBatch.amendmentsConfirmed"
              color="indigo"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs8 class="flex-container-space-between">
            <v-text-field
              v-model="editedBatch.amendmentsNotes"
              label="Amendments notes"
              type="text"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 v-if="$store.state.user.userAuthClass.name=='Administrator'">
            <v-switch v-model="editedBatch.hasDuplicate" label="Duplicate" style="margin-top: 0px"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading" :disabled="closed">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>

    <lines-view :batch="batch" :selectedDate="editedBatch.date"></lines-view>

    <v-dialog lazy v-model="addLineDialog" max-width="700px" @keydown.esc="addLineDialog = false">
      <add-line v-if="addLineDialog" :batch="editedBatch" @close="addLineDialog = false"></add-line>
    </v-dialog>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import AllocationService from '@/services/requests/allocationService'
import DatePickerWrapper from '@/components/ui/datePickerWrapper'
import getSites from '@/services/mixins/getMasterFiles/getSites'

import BatchValidation from '../validation/batchValidation'

import AddLine from './lines/lineAdd'
import LinesView from './lines/linesView'
export default {
  mixins: [getSites, BatchValidation],
  components: {
    DatePickerWrapper,
    LinesView,
    AddLine,
  },
  props: {
    batch: Object,
  },
  mounted() {
    this.getBatchLinesByDate(this.editedBatch.date)
  },
  data() {
    return {
      editedBatch: Object.assign({}, this.batch),
      loading: false,
      addLineDialog: false,
      statusOptions: ['CONFIRMED', 'REVIEW', 'NOT SET'],
    }
  },
  watch: {
    selectedDate(val) {
      if (!!val) this.getBatchLinesByDate(val)
    },
  },
  computed: {
    fetchBatches: Store.getSet({
      store: 'allocationStaging',
      prop: 'fetchBatches',
    }),
    batchLinesByDate: Store.getSet({
      store: 'batchAllocations',
      prop: 'batchLinesByDate',
    }),
    different() {
      return !this._.isEqual(this.batch, this.editedBatch)
    },
    closed() {
      return this.batch.commited
    },
    selectedDate() {
      return this.editedBatch.date
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.editedBatch = Object.assign({}, this.batch)
      this.close()
    },
    submitEditBatch() {
      if (!this.$refs.editBatchForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.save()
    },
    save() {
      this.loading = true
      AllocationService.updateBatch(this.editedBatch)
        .then((result) => {
          result.data.result.updated = true
          this.$store.commit('allocationStaging/updateArrayStateByValue', {
            prop: 'batches',
            value: this.batch,
            editedValue: result.data.result,
          })

          this.editedBatch = Object.assign({}, result.data.result)
          this.snack({ text: 'Batch was edited!', color: 'green' })
          this.loading = false
          this.close()
        })
        .catch((err) => {
          this.loading = false
          this.snack({ text: err.response.data.message, color: 'red' })
        })
    },
    getBatchLinesByDate(date) {
      return AllocationService.getBatchLinesByDate(date)
        .then((result) => {
          this.batchLinesByDate = result.data.result
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>